export const FooterCardTitle: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <p className="text-[18px]/[22.68px] font-semibold">{children}</p>;
};
